<template>
  <div class="construction-container">
    <div class="content-wrapper">
      <i class="fa-solid fa-screwdriver-wrench construction-icon"></i>
      
      <h1 class="title">Page Under Construction</h1>
      <p class="subtitle">We're working hard to bring you this page. Please check back soon!</p>
    </div>
    <img :src="logo" alt="Vertex Cyber Security Logo" class="logo">
  </div>
</template>

<script>
import vertexLogo from '@/assets/img/vertex_logo.png';

export default {
  // Renamed the component to be more descriptive
  name: 'PageUnderConstruction',
  data() {
    return {
      logo: vertexLogo,
    };
  },

   mounted() {
      // Track the PageView event for this specific form
      if (window.fbq) {
         window.fbq('track', 'PageView');
      }
   },
};
</script>

<style scoped>
/* Import the Roboto font from Google Fonts */
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap');

/* Renamed the main container class */
.construction-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-image: url("~@/assets/img/BG_Mountain.jpg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  font-family: 'Roboto', sans-serif;
  text-align: center;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 50px;
  background-color: rgba(255, 255, 255, 0.7);
  padding: 40px 60px;
  border-radius: 15px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
}

/* New style for the Font Awesome icon, replacing the old checkmark styles */
.construction-icon {
  width: 80px;
  height: 80px;
  font-size: 65px; /* Adjust size of icon glyph */
  color: #555; /* Matched color to subtitle for a clean look */
  display: flex;
  align-items: center;
  justify-content: center;
  animation: check-fade-in 1s ease-in-out forwards;
}

.title {
  font-size: 2.5rem;
  font-weight: 500;
  color: #333; /* Dark color for title */
  margin: 20px 0 10px;
  opacity: 0;
  animation: fade-in 1s ease-in-out 1.2s forwards;
}

.subtitle {
  font-size: 1.2rem;
  color: #555; /* Slightly lighter dark color for subtitle */
  margin-top: 0;
  opacity: 0;
  animation: fade-in 1s ease-in-out 1.5s forwards;
}

.logo {
  max-width: 250px;
  opacity: 0;
  border: 1px solid rgba(255, 255, 255, 0.5);
  padding: 5px 10px;
  animation: fade-in 1s ease-in-out 1.8s forwards;
}

/* Animations */
@keyframes fade-in {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes check-fade-in {
  from { opacity: 0; transform: scale(0.8); }
  to { opacity: 1; transform: scale(1); }
}
</style>